import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VormingService } from 'src/app/services/vorming.service';

@Component({
  selector: 'app-vorming',
  templateUrl: './vorming.component.html',
  styleUrls: ['./vorming.component.sass']
})
export class VormingComponent implements OnInit {

  vormingId:any;
  vorming:any;
  vormingen:any = [];

  constructor(
    private vormingService:VormingService,
    private activatedRoute: ActivatedRoute,
    private router:Router) { }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;
    if(!params) return;
    this.vormingId = params["vorming"];

    this.vormingService.getVormingen().subscribe(data => {
      for(let v of data.data) {
        v = this.vormingService.populateVorming(v);
        if(v.id == this.vormingId) {
          this.vorming = v;
        } else {
          this.vormingen.push(v);
        }
      }
    });
  }

}
